
import React from 'react';
import { useNavigate } from "react-router-dom";
import { EquiForgeLogo } from '@/components/branding';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  className?: string;
  showText?: boolean;
  clickable?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'lg', 
  className,
  showText = true,
  clickable = false
}) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (clickable) {
      navigate('/');
    }
  };
  
  return (
    <div onClick={handleClick}>
      <EquiForgeLogo
        size={size}
        showText={showText}
        className={clickable ? "cursor-pointer hover:opacity-80 transition-opacity duration-200" : ""}
      />
    </div>
  );
};

export default Logo;
